import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-notebook",
  "use": "spr-notebook-usage",
  "viewBox": "0 0 392.5 512",
  "content": "<symbol viewBox=\"0 0 392.5 512\" id=\"spr-notebook\">\n<style type=\"text/css\">\n\t#spr-notebook .st0{fill:#FFFFFF;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M85.3,0H0v512h85.3h307.2V0H85.3z M17.1,494.9V17.1h51.2v477.9H17.1z M375.5,494.9H85.3V17.1h290.1V494.9z\" />\n\t<path class=\"st0\" d=\"M332.8,204.8V85.3H128v119.5H332.8z M145.1,102.4h170.7v85.3H145.1V102.4z\" />\n\t<rect x=\"170.7\" y=\"119.5\" class=\"st0\" width=\"119.5\" height=\"17.1\" />\n\t<rect x=\"170.7\" y=\"153.6\" class=\"st0\" width=\"119.5\" height=\"17.1\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/notebook.svg
// module id = 335
// module chunks = 0